import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children, activeTab, onTabChange }) => {
    return (
        <div className="layout">
            <Header activeTab={activeTab} onTabChange={onTabChange} />
            <main className="main-content">
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
